import script from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFolderDetails.vue?vue&type=style&index=0&id=233c0850&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233c0850"]])

export default __exports__